import { Component, HostListener, inject } from '@angular/core';
import { AssetsIconsService } from '@stillmandigital/assets-icons';
import { environment } from 'environments/environment';
import { GlobalSearchService } from './shell/services/global-search.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [AssetsIconsService],
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AppComponent {
  private readonly _globalSearch = inject(GlobalSearchService);

  constructor() {
    const assetsIconsService = inject(AssetsIconsService);

    assetsIconsService.registerGlobalIcons();

    document.body.classList.add(environment.isBermuda ? 'theme-bermuda' : 'theme-default');

    document.title = environment.isBermuda
      ? 'Bermuda Backoffice'
      : environment.production
        ? 'US Backoffice'
        : 'Sandbox BO';
  }

  @HostListener('window:keydown', ['$event'])
  public handleKeydown(event: KeyboardEvent) {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      this._globalSearch.open();
    }
  }
}
